import React from 'react'
import { ToolTipContentProps } from './ToolTipContent.types'
import styles from './ToolTipContent.module.scss'
import cl from 'classnames'
import { HorizontalLine, ImageSquare, Text1 } from 'components/shared'
import { ColorCircle } from '../ColorCircle'

const ToolTipContentComponent = (props: ToolTipContentProps) => {
  const {
    className,
    style,
    header,
    list
  } = props

  return (
    <div
      className={cl(styles.container, className)}
      style={style}
    >
      <div className={styles.headerLine}>
        <Text1 className={styles.text}>
          {header.label}
        </Text1>
        <Text1 className={styles.textExtraMargin}>
          {header.value}
        </Text1>
      </div>
      <HorizontalLine className={styles.line} />

      {list.map(({ label, value, color, image }, index) => {
        return (
          <div
            key={index}
            className={styles.listLine}
          >
            <div className={styles.listLineGroup}>
              {color && (
                <ColorCircle color={color} />
              )}
              {image && (
                <ImageSquare
                  src={image}
                  width={30}
                  showBorder
                  style={{ marginLeft: color ? 10 : 0 }}
                />
              )}
              <Text1
                className={styles.boldText}
                style={{ marginLeft: (color || image) ? 10 : 0 }}
              >
                {label}
              </Text1>
            </div>
            <Text1 className={styles.boldTextExtraMargin}>
              {value}
            </Text1>
          </div>
        )
      })}
    </div>
  )
}

const ToolTipContent = ToolTipContentComponent
export { ToolTipContent }
